import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Search, Home, Sprout } from "lucide-react";
import SectionReveal from "@/components/SectionReveal";
import OrganicShapes from "@/components/OrganicShapes";

export default function NotFound() {
    return (
        <main
            data-testid="not-found-page"
            className="relative min-h-[100svh] bg-white flex items-center justify-center pt-28 pb-20 overflow-hidden"
        >
            <OrganicShapes variant="mixed" />
            <div className="relative max-w-3xl mx-auto px-6 md:px-10 text-center">
                <SectionReveal>
                    <motion.div
                        animate={{ rotate: [0, -6, 6, -4, 0] }}
                        transition={{
                            duration: 4,
                            repeat: Infinity,
                            repeatType: "loop",
                            ease: "easeInOut",
                        }}
                        className="mx-auto w-20 h-20 rounded-full bg-seedh-surface-green border border-seedh-border flex items-center justify-center"
                    >
                        <Sprout className="w-9 h-9 text-seedh-green" />
                    </motion.div>
                </SectionReveal>

                <SectionReveal delay={0.08}>
                    <div className="font-display text-[7rem] md:text-[10rem] leading-none text-seedh-blue mt-8 tracking-tighter">
                        4<span className="font-display-italic text-seedh-green">0</span>4
                    </div>
                </SectionReveal>

                <SectionReveal delay={0.16}>
                    <h1 className="font-display text-3xl md:text-4xl text-seedh-text leading-tight mt-2">
                        This route hasn't been planted yet.
                    </h1>
                </SectionReveal>

                <SectionReveal delay={0.22}>
                    <p className="mt-6 text-base text-seedh-muted max-w-lg mx-auto leading-relaxed">
                        The page you're looking for doesn't exist — or has been
                        replaced (much like a sapling after a difficult
                        monsoon). Try one of these instead:
                    </p>
                </SectionReveal>

                <SectionReveal delay={0.3}>
                    <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
                        <Link
                            to="/"
                            data-testid="back-home"
                            className="btn-primary rounded-full px-7 py-4 text-sm font-semibold inline-flex items-center justify-center gap-2"
                        >
                            <Home className="w-4 h-4" />
                            Back to Home
                        </Link>
                        <Link
                            to="/tracker"
                            className="btn-outline rounded-full px-7 py-4 text-sm font-semibold inline-flex items-center justify-center gap-2"
                        >
                            <Search className="w-4 h-4" />
                            Open the Tracker
                        </Link>
                        <Link
                            to="/donate"
                            className="rounded-full bg-seedh-green text-white px-7 py-4 text-sm font-semibold inline-flex items-center justify-center gap-2 hover:bg-seedh-green-hover transition-colors"
                        >
                            Choose a Cause
                            <ArrowRight className="w-4 h-4" />
                        </Link>
                    </div>
                </SectionReveal>
            </div>
        </main>
    );
}
